import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {FeatureDto} from '../../../api';
import {CheckoutFeatureListItemComponent} from "./checkout-feature-list-item/checkout-feature-list-item.component";

/**
 * Rendert die Feature-Zeilen einer Preiskarte generisch aus den Datensätzen der Tabelle
 * product_feature – Beschriftung, Wert, Einheit und Reihenfolge kommen ausschließlich aus der DB.
 */
@Component({
  selector: 'app-shop-feature-list',
  templateUrl: './checkout-feature-list.component.html',
  styleUrls: ['./checkout-feature-list.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CheckoutFeatureListItemComponent,
  ]
})
export class CheckoutFeatureListComponent {

  @Input() features: FeatureDto[] = [];
  @Input() active: boolean = false;
}
